import React from 'react';
import './videoSrc.css'

function C2wSuperxVideoSrc( { videoSource } ) {
    return (
        <div className='C2wSuperxLanding_video_ctn'>
            <video className='C2wSuperxLanding_video_holder' key={videoSource} src={videoSource} autoPlay loop muted>
                <source src={videoSource} type='video/mp4' />
            </video>
            <div className='videobg'>

            </div>
        </div>
    )
}

export default C2wSuperxVideoSrc;
